import { render, staticRenderFns } from "./LineAreaChart.vue?vue&type=template&id=0af51610&"
import script from "./LineAreaChart.vue?vue&type=script&lang=js&"
export * from "./LineAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./LineAreaChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af51610')) {
      api.createRecord('0af51610', component.options)
    } else {
      api.reload('0af51610', component.options)
    }
    module.hot.accept("./LineAreaChart.vue?vue&type=template&id=0af51610&", function () {
      api.rerender('0af51610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/LineAreaChart.vue"
export default component.exports